import { Simulation } from '~/types'

export const getStatusColor = (status: Simulation.Status): string => {
  switch (status) {
    case 'Error':
      return '#E96D76'
    case 'Failed':
      return '#E96D76'
    case 'Running':
      return '#0DADEA'
    case 'Succeeded':
      return '#18BE94'
    case 'Skipped':
      return '#CCD6DD'
    case 'Omitted':
      return '#CCD6DD'
    case 'Suspended':
      return '#CCD6DD'
    case 'Pending':
      return '#F4C030'
    default:
      return '#0DADEA'
  }
}
